// config/config.js
// Centralized configuration for API endpoints and environment variables

const config = {
  // API Base URL from environment variable
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://portalapi.greenfieldserver.co.uk:3447',

  // External API token for Companies House and Address lookups
  // This is a public-facing token for these specific services
  EXTERNAL_API_TOKEN: import.meta.env.VITE_EXTERNAL_API_TOKEN || '',

  // API Endpoints
  endpoints: {
    // Authentication endpoints (with 2FA support)
    signin: '/portal/users/login',
    verify2FA: '/portal/users/verify-2fa',
    setup2FA: '/portal/users/2fa/setup',
    verifySetup2FA: '/portal/users/2fa/verify-setup',

    // Form endpoints
    forms: {
      get: '/api/users/forms/get',
      save: '/api/users/forms/save',
    },

    // External API endpoints
    companies: {
      search: '/companies/companysearch',
    },
    address: {
      find: '/api/address/find',
      get: '/api/address/get',
    },
  },
};

export default config;
